function updateInputValidity(input) {
  const parent = input.parentElement,
    describedBy = document.querySelector(
      `#${input.getAttribute("aria-describedby")}`
    );
  for (const constraint in input.validity) {
    if (input.validity[constraint]) {
      updateOnConstraint(input, parent, describedBy, constraint);
      break;
    }
  }
}

function updateOnConstraint(input, parent, describedBy, constraint) {
  if (constraint === "valid") {
    updateValidConstraint(input, parent, describedBy);
  } else {
    updateInvalidConstraint(input, parent, describedBy, constraint);
  }
}

function updateValidConstraint(input, parent, describedBy) {
  input.classList.remove("invalid");
  input.setAttribute("aria-invalid", "false");
  parent.classList.remove("invalid");
  if (describedBy) {
    describedBy.classList.add("hidden");
    describedBy.innerHTML = "";
  }
}

function updateInvalidConstraint(input, parent, describedBy, constraint) {
  const invalidMessage = input.getAttribute(`data-${constraint}-message`);
  if (!invalidMessage) {
    console.log(
      `Input "${input.id}" with constraint "${constraint}" has no invalid message`
    );
  }
  input.classList.add("invalid");
  input.setAttribute("aria-invalid", "true");
  parent.classList.add("invalid");
  if (describedBy) {
    describedBy.classList.remove("hidden");
    describedBy.innerHTML = invalidMessage;
  }
}

function isFormNoValidate(element) {
  const formNoValidate = element.getAttribute("formnovalidate");
  return formNoValidate === "" || formNoValidate === "formnovalidate";
}

export default function () {
  const form = document.querySelector("form"),
    notHiddenInputs = form
      ? form.querySelectorAll("input:not([type=hidden])")
      : [];
  let submitButton = null;

  function onClick(event) {
    if (event.target.tagName === "BUTTON" && event.target.type === "submit") {
      submitButton = event.target;
    }
  }

  function onSubmit(event) {
    if (!isFormNoValidate(submitButton)) {
      if (!event.target.checkValidity()) {
        event.preventDefault();
      }
      for (const input of notHiddenInputs) {
        updateInputValidity(input);
      }
    }
  }

  if (form) {
    form.addEventListener("click", onClick);
    form.addEventListener("submit", onSubmit);
  }
}
